import { Navigate } from "react-router-dom"
import { Box, HStack, Separator, Spacer, Stack } from "@chakra-ui/react"
import { Section, Text } from "@/components"
import { useAuth } from "@/contexts"
import { useCompanyDealData, useDealTrends, useRecentClientCount, useRecentDealCount } from "@/hooks"
import { DashboardItem, DealTrendsChart } from "./components"

export const DealManagerDashboardComponent = () => {
  const { user } = useAuth()
  const { data: clientData, isLoading: isClientLoading } = useRecentClientCount()
  const { data: dealData, isLoading: isDealLoading } = useRecentDealCount()
  const { data: dealTrends, isLoading: isDealTrendsLoading } = useDealTrends()
  const { data: companyDealData, isLoading: isCompanyDealDataLoading } = useCompanyDealData()

  if (!user) {
    return <div>Loading...</div>
  }

  // Unreachable for a non-deal-manager today, since DealManagerDashboardPage
  // gates this component's only route. Kept and matched to that page's
  // behaviour so the two cannot drift if the nesting ever changes.
  if (user.userType === "client") {
    return <Navigate to="/deals" replace />
  }

  if (user.userType !== "deal_manager") {
    return <div>Please contact support. Your account is not set up for this area.</div>
  }

  return (
    <Section>
      <Text fontSize="2xl" fontWeight="bold">
        Welcome Back, {user.firstName}!
      </Text>
      <Separator />
      <HStack my={5} gap={5}>
        <DashboardItem isFirst={true} isLoading={isDealLoading} label="New OG's Created" dashboardData={dealData} />
        <DashboardItem isFirst={false} isLoading={isClientLoading} label="New Clients" dashboardData={clientData} />
      </HStack>
      <Stack direction={{ base: "column", md: "row" }} w="100%" align="flex-start">
        <Box w={{ base: "100%", md: "60%" }}>
          <DealTrendsChart trendData={dealTrends} />
        </Box>
        <Stack
          w={{ base: "100%", md: "40%" }}
          maxH={{ base: "300px", md: "423px" }}
          p={5}
          border="1px"
          borderColor="gray.200"
          borderRadius={10}
          boxShadow="sm"
          bg="white"
          overflowY="auto"
        >
          <Text fontSize="sm" color="gray.500">
            Top Companies
          </Text>
          <Separator />
          {
            companyDealData.slice(0, 50).map((company) => (
              <HStack key={company.companyName} justify="space-between">
                <Text fontSize="md">{company.companyName}</Text>
                <Text fontSize="md" fontWeight="bold">{company.dealCount}</Text>
              </HStack>
            ))
          }
          <Spacer />
        </Stack>
      </Stack>
    </Section>
  )
}
